export const actionNamespacer = (namespace) => {
  return (data = undefined) => {
    return {
      namespace,
      data
    };
  }
};